import React, { FunctionComponent, useEffect, useState, } from 'react'
import { useTranslation } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

import './DashboardInfo.css';

import { Button, } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { push } from '@lagunovsky/redux-react-router';
import { useParams } from 'react-router-dom';

interface Props {
}

export type DashboardInfoId = 'x20-please-sign-in' | 's20-please-start-device';

const DashboardInfo:FunctionComponent<Props> = ( props ) => {

  const { t, i18n } = useTranslation( [ 'dashboardInfo' ] );
  const { t: tCommon } = useTranslation( [ 'common' ] );
  const dispatch = useDispatch<AppDispatch>();

  const onBack = () => {
    dispatch( push('/dashboard') );
  }

  const { id = '' } = useParams<{ id: string }>();

  const render404 = () => {
    return <>
    <h1>404</h1>
    Content not found
    </>
  }

  return (
  <AuthLayout header={ true }>
    {/* Check if translations keys actually exists, if not we show 404 */}
    { !i18n.exists( `${ id }-title`, { ns: 'dashboardInfo' } ) || !i18n.exists( `${ id }-content`, { ns: 'dashboardInfo' } ) ?
    render404() :
    <div>
      <div className="page page-dashboard-info">
        <h2>{ t( `${ id }-title` ) }</h2>
        <p>{ t( `${ id }-content` ) }</p>
        <Button
          variant='text'
          type="submit"
          fullWidth
          onClick={ onBack }
        >
        { t( 'back' ) }
        </Button>
      </div>
    </div>
    }
  </AuthLayout>
  );

}

export default DashboardInfo;
